/**
 * @waw/shared-types — enums partagés (API + fronts). Source de vérité : migrations SQL.
 * JS pur + JSDoc (pas de build step).
 */

/** @typedef {'super_admin'|'staff_manager'} RoleValue */
export const Role = Object.freeze({
  SUPER_ADMIN: 'super_admin',
  STAFF_MANAGER: 'staff_manager',
});

/** @typedef {'pending_payment'|'pending_validation'|'confirmed'|'cancelled'|'rejected'} ReservationStatusValue */
export const ReservationStatus = Object.freeze({
  PENDING_PAYMENT: 'pending_payment',
  PENDING_VALIDATION: 'pending_validation',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  REJECTED: 'rejected',
});

/** Clés des 7 types d'événements seedés. */
export const EventType = Object.freeze({
  ANNIVERSAIRE: 'anniversaire',
  SORTIE_SCOLAIRE: 'sortie_scolaire',
  TEAM_BUILDING: 'team_building',
  BOWLING: 'bowling',
  ESCAPE_GAME: 'escape_game',
  PRIVATISATION: 'privatisation',
  AUTRES: 'autres',
});

/** Codes des sites WAW. */
export const SiteCode = Object.freeze({
  CASA: 'WAW_CASA',
  WAVE: 'WAW_WAVE',
  FES: 'WAW_FES',
  MARRAKECH: 'WAW_MARRAKECH',
  TANGER: 'WAW_TANGER',
});

/** @typedef {'active'|'coming_soon'|'inactive'} SiteStatusValue */
export const SiteStatus = Object.freeze({
  ACTIVE: 'active',
  COMING_SOON: 'coming_soon',
  INACTIVE: 'inactive',
});

/** @typedef {'ai_auto'|'staff_manager'|'super_admin'} DecisionSourceValue */
export const DecisionSource = Object.freeze({
  AI_AUTO: 'ai_auto',
  STAFF_MANAGER: 'staff_manager',
  SUPER_ADMIN: 'super_admin',
});

/** Décisions du workflow IA n8n. */
export const AiDecision = Object.freeze({
  AUTO_CONFIRM: 'auto_confirm',
  AUTO_CANCEL: 'auto_cancel',
  RECOMMEND: 'recommend',
});

/** Statuts payment_transactions. */
export const PaymentStatus = Object.freeze({
  INITIATED: 'initiated',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  REFUNDED: 'refunded',
});
